import * as React from 'react'
import type { SVGProps } from 'react'
const SvgSoundcloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.449 18.1047V6.8099q0-.5396.3168-.6435a5.93 5.93 0 0 1 4.279.582 6.045 6.045 0 0 1 2.1868 2.0393 6.14 6.14 0 0 1 .968 2.849 3.32 3.32 0 0 1 1.3299-.2695c.9559 0 1.7732.3432 2.4519 1.0285S23 13.9049 23 14.8663c0 .9691-.3399 1.7963-1.0186 2.4816s-1.4927 1.0274-2.442 1.0274l-8.9056-.011a.24.24 0 0 1-.1386-.1133.31.31 0 0 1-.0462-.1463m-2.3958-.3003c0 .3806.253.5709.7579.5709.506 0 .7579-.1903.7579-.572V7.4237c0-.5819-.187-.9779-.5269-1.0208-.2299-.0297-.4422-.0297-.66.1573-.22.187-.3289.5247-.3289.8635zm-2.354-.0319q0 .302.2145.4521c.143.1001.3278.1507.5533.1507a.9.9 0 0 0 .5368-.1507c.1397-.1001.2101-.2508.2101-.451v-6.4064a.765.765 0 0 0-.22-.55.707.707 0 0 0-.528-.2277.736.736 0 0 0-.5423.2277.755.755 0 0 0-.2244.55zm-2.3452-.3322c0 .2013.0704.352.2101.4521s.319.1507.5379.1507c.2255 0 .407-.0506.5478-.1507.1397-.1001.209-.2508.209-.451v-7.018a.735.735 0 0 0-.22-.5357.726.726 0 0 0-.5368-.2233.714.714 0 0 0-.528.2233.735.735 0 0 0-.22.5346zM1 16.1533c0 .2772.099.4862.297.6281a.8021.8021 0 0 0 .6347.1507c.2112-.0418.3597-.1177.4455-.2288.0847-.11.1276-.2937.1276-.55v-3.0107a.747.747 0 0 0-.22-.5445.726.726 0 0 0-.5379-.2233.715.715 0 0 0-.5269.2233c-.1463.1485-.22.33-.22.5445z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSoundcloud
